var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 22.5C4.44772 22.5 4 22.0523 4 21.5V3.5C4 2.94772 4.44772 2.5 5 2.5H19C19.5523 2.5 20 2.94772 20 3.5V6.5H18V4.5H6V20.5H18V18.5H20V21.5C20 22.0523 19.5523 22.5 19 22.5H5ZM18 16.5V13.5H11V11.5H18V8.5L23 12.5L18 16.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOut);
export default __webpack_public_path__ + "static/media/log-out.27ae9c8b81f224699f0149edc87333ff.svg";
export { ForwardRef as ReactComponent };